/*
 * @Author: dongbo 254126189@qq.com
 * @Date: 2024-01-02 19:02:42
 * @LastEditors: dongbo 254126189@qq.com
 * @LastEditTime: 2024-01-09 14:47:31
 * @FilePath: /gwm-hippo-h5/hippo-app-h5/src/utils/sensorsdata/config.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { brandCode } from '@gwm/bridge'

const config: Record<
  'dev' | 'prod',
  Record<
    brandCode,
    {
      serverUrl: string
      platformName: string
    }
  >
> = {
  dev: {
    1: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=haf',
      platformName: '哈弗APP',
    },
    2: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=wey',
      platformName: '魏APP',
    },
    3: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=oula',
      platformName: '欧拉ORA',
    },
    5: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=pika',
      platformName: '长城炮App',
    },
    7: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=tank',
      platformName: '坦克APP',
    },
    9: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=soul',
      platformName: '灵魂摩托车APP',
    },
    10: {
      serverUrl: 'https://odatatest.gwm.cn/sa?project=SAPP',
      platformName: '聚合APP',
    },
  },
  prod: {
    1: {
      serverUrl: 'https://odata.gwm.cn/sa?project=haf',
      platformName: '哈弗APP',
    },
    2: {
      serverUrl: 'https://odata.gwm.cn/sa?project=wey',
      platformName: '魏APP',
    },
    3: {
      serverUrl: 'https://odata.gwm.cn/sa?project=oula',
      platformName: '欧拉ORA',
    },
    5: {
      serverUrl: 'https://odata.gwm.cn/sa?project=pika',
      platformName: '长城炮App',
    },
    7: {
      serverUrl: 'https://odata.gwm.cn/sa?project=tank',
      platformName: '坦克APP',
    },
    9: {
      serverUrl: 'https://odata.gwm.cn/sa?project=soul',
      platformName: '灵魂摩托车APP',
    },
    10: {
      serverUrl: 'https://odata.gwm.cn/sa?project=SAPP',
      platformName: '聚合APP',
    },
  },
}

export default config
